import RestService from '../services/rest';

async function getSettings() {
  return RestService.getRest('settings');
}

async function getSettingsLong() {
  return RestService.getAuthenticated('panel/settingsLong/getAll');
}

async function updateSettings(settings) {
  return RestService.putAuthenticated('panel/settings/update', settings);
}

async function updateSettingsLong(settings) {
  return RestService.putAuthenticated('panel/settingsLong/update', settings);
}

async function uploadLogo(file, name) {
  const fd = new FormData();
  fd.append('file', file);
  return RestService.postAuthenticated(`panel/settings/import?&name=${name}`,
    fd, {
      'Content-Type': 'multipart/form-data',
    });
}

export default {
  getSettings,
  getSettingsLong,
  updateSettings,
  updateSettingsLong,
  uploadLogo,
};
